<template>
  <router-link
    class="nav-link"
    :to="to"
    v-bind="$attrs"
    @click="handleNavClick"
  >
    <div
      class="text-center bg-white shadow icon icon-shape icon-sm border-radius-md d-flex align-items-center justify-content-center"
      :class="this.$store.state.isRTL ? ' ms-2' : 'me-2'"
    >
      <slot name="icon"></slot>
    </div>
    <span
      class="nav-link-text"
      :class="this.$store.state.isRTL ? ' me-1' : 'ms-1'"
      ><portal-text :message="navText" :help="false" /></span
    >
  </router-link>
</template>
<script>
export default {
  name: "sidenav-collapse",
  props: {
    to: {
      type: [Object, String],
      required: true,
    },
    navText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  methods: {
    handleNavClick() {
      // Close sidenav automatically on mobile
      if (window.innerWidth < 1200) {
        this.$store.commit("navbarMinimize");
      }
    },
  },
};
</script>
